export default "__VITE_ASSET__Cdf9HJvJ__"